import { configureStore } from "@reduxjs/toolkit";
import reducer from "./slice";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Uses localStorage

// Persist Config
const persistConfig = {
  key: "askTime", // Key for localStorage
  storage, // Storage type (localStorage)
  whitelist: ["user"], // Only persist these
};

// Wrap Reducers with Persist Reducer
const persistedReducer = persistReducer(persistConfig, reducer.reducer);

// Create Store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable warnings for non-serializable values
    }),
});

export const persistor = persistStore(store);
export default store;
